import { render, staticRenderFns } from "./HumanBody.vue?vue&type=template&id=c63ca990&scoped=true&"
import script from "./HumanBody.vue?vue&type=script&lang=js&"
export * from "./HumanBody.vue?vue&type=script&lang=js&"
import style0 from "./HumanBody.vue?vue&type=style&index=0&id=c63ca990&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63ca990",
  null
  
)

export default component.exports